import './report-schedules-list';

import * as angular from 'angular';

import { ReportSchedulesComponent } from './report-schedules.component';

angular.module('report-schedules', ['report-schedules-list']).component('reportSchedules', ReportSchedulesComponent);
